angular.module('picmonicng').component('homeQuickStartList', {
  templateUrl: '/templates/app/components/home-quick-start-list/home-quick-start-list.html',
  bindings: {
    settings: '=',
  },
  controller: [
    '$rootScope',
    '$scope',
    'LocalStorageService',
    'Picmonics',
    'PlaylistService',
    '$modal',
    'User',
    'UserService',
    function ($rootScope, $scope, LocalStorageService, Picmonics, PlaylistService, $modal, User, UserService) {
      var $ctrl = this;

      $scope.UserService = UserService;

      //quickStartList
      $scope.nextPageRecent = function () {
        if ($scope.page === -1) {
          return;
        }
        User.recommended({
          type: 'recent',
          page: ++$scope.recentPage,
        }).$promise.then(function (data) {
          if ($scope.recentPicmonics.recent) {
            $scope.recentPicmonics.recent = $scope.recentPicmonics.recent.concat(data.recent);
          }
          if (!data.recent.length) {
            $scope.page = -1;
          }
        });
      };

      $scope.selectTab = function (tab) {
        switch (tab) {
          case 'recent':
            /**
             * GET /api/v3/user/recommended
             * \Picmonic\Http\Controllers\API\V3\UserController::recommended
             */
            $scope.recentPicmonics = User.recommended({
              type: 'recent',
            });

            $scope.recentPicmonics.$promise.then(response => {
              const cards = response.recent.map(card => {
                return new Picmonics(card);
              });

              response.recent = cards;
            });

            $scope.recentPage = 0;
            $scope.nextPageRecent();
            break;
          case 'recommended':
            /**
             * GET /api/v3/user/recommended
             * \Picmonic\Http\Controllers\API\V3\UserController::recommended
             */
            $scope.recommendedPicmonics = User.recommended({
              type: 'home',
            });

            $scope.recommendedPicmonics.$promise.then(response => {
              const cards = response.cards.map(card => {
                return new Picmonics(card);
              });

              response.cards = cards;
            });
            break;
          case 'new':
            /**
             * GET /api/v2/picmonics
             * \Picmonic\Http\Controllers\API\V2\PicmonicsController::index
             */
            $scope.newPicmonics = Picmonics.get({
              type: 'trending',
              filter: 'new',
              limit: 20,
            });

            $scope.newPicmonics.$promise.then(response => {
              const cards = response.results.map(card => {
                return new Picmonics(card);
              });

              response.results = cards;
            });
            break;
          case 'trending':
            $scope.trendingFilter = { value: 'school' };
            /**
             * GET /api/v2/picmonics
             * \Picmonic\Http\Controllers\API\V2\PicmonicsController::index
             */
            $scope.trending = Picmonics.query({
              type: 'trending',
              filter: $scope.trendingFilter.value,
              limit: 20,
            });
            break;
          case 'weakest':
            /**
             * GET /api/v3/user/weakest
             * \Picmonic\Http\Controllers\API\V3\UserController::weakest
             */
            $scope.weakest = User.weakest({ perPage: 20 });

            $scope.weakest.$promise.then(response => {
              const cards = response.data.map(card => {
                return new Picmonics(card);
              });

              response.data = cards;
            });
            break;
          case 'updated':
            /**
             * GET /api/v2/picmonics
             * \Picmonic\Http\Controllers\API\V2\PicmonicsController::index
             */
            $scope.updatedPicmonics = Picmonics.get({
              type: 'trending',
              filter: 'updated',
              limit: 50,
            });

            $scope.updatedPicmonics.$promise.then(response => {
              const cards = response.results.map(card => {
                return new Picmonics(card);
              });

              response.results = cards;
            });
            break;
          case 'trial-playlist':
            $scope.playlists = PlaylistService.getCards({
              playlist_id: 'trial-playlist',
            });

            $scope.playlists.$promise.then(response => {
              const cards = response.map(card => {
                return new Picmonics(card);
              });

              response.results = cards;
            });
            break;
          case 'bookmarked':
            $scope.playlists = PlaylistService.getCards({
              playlist_id: 'bookmarked',
            });

            $scope.playlists.$promise.then(response => {
              const cards = response.map(card => {
                return new Picmonics(card);
              });

              response.results = cards;
            });

            break;
        }
        $scope.tab = $ctrl.settings.quickStartList.tab = tab;
      };

      $ctrl.$onInit = function () {
        $scope.selectTab($ctrl.settings.quickStartList.tab);
      };

      $scope.getNumberOfMinutes = function (audioLength) {
        $scope.intAudioLength = parseInt(audioLength, 10);

        if (!audioLength || !$scope.intAudioLength) {
          $scope.time = 0;
        } else if (parseInt(audioLength, 10) < 60) {
          secs = Math.round(parseInt(audioLength, 10), 2);
          $scope.time = secs + ' sec' + (secs > 1 ? 's' : '');
        } else if (parseInt(audioLength, 10) < 3600) {
          mins = Math.round(parseInt(audioLength, 10) / 60);
          $scope.time = mins + ' min' + (mins > 1 ? 's' : '');
        } else {
          hours = Math.floor(parseInt(audioLength, 10) / 3600);
          mins = Math.round((parseInt(audioLength, 10) / 60) % 60);
          $scope.time = hours + ' hr' + (hours > 1 ? 's' : '') + ' ' + mins + ' min' + (mins > 1 ? 's' : '');
        }

        return $scope.time;
      };
    },
  ],
});
